"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
exports.number = function (value, range, easing, transform) { return function (props) {
    var theme = props.theme;
    var ranges = core_1.getRange(range, theme);
    var values = core_1.getValue(value, theme);
    var val;
    if (ranges.length === 1) {
        // If range has only one item, return it
        val = ranges[0];
    }
    else if (ranges.length === 2) {
        // If range has two items, interpolate between them and return it
        val = core_1.interpolate(values, ranges, easing);
    }
    else if (ranges.length > 2) {
        // If range has more entries, loop through them and interpolate between two values
        var step = 1 / (ranges.length - 1);
        for (var i = 0; i < ranges.length; i += 1) {
            if (values < i * step) {
                var percent = ((values - (i - 1) * step) / (i * step - (i - 1) * step)) * 1;
                val = core_1.interpolate(percent, [ranges[i - 1], ranges[i]], easing);
                break;
            }
            else if (values === i * step) {
                val = ranges[i];
                break;
            }
        }
    }
    return transform ? transform(val) : val;
}; };
exports.useNumber = function (value, range, easing, transform) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.number(value, range, easing, transform)({ theme: theme });
};
//# sourceMappingURL=number.js.map